<lib-dialog
  [title]="'cookies-dialog.text.title' | translate"
  [displayActionContainerAsColumnOnMobile]="true"
  [hideCloseButtonIcon]="true"
  [isLoading]="isLoading"
>
  <div body>
    <p [innerHTML]="'cookies-dialog.text.content-1' | translate"></p>
    <p [innerHTML]="'cookies-dialog.text.content-2' | translate"></p>
    <p [innerHTML]="'cookies-dialog.text.content-3' | translate"></p>

    <button
      *ngIf="!isOpenSetting; else settingsTemplate"
      mat-button
      color="primary"
      class="full-width"
      (click)="isOpenSetting = true"
    >
      {{ 'cookies-dialog.buttons.setting' | translate }}
    </button>

    <ng-template #settingsTemplate>
      <lib-spacer></lib-spacer>

      <form [formGroup]="submitForm">
        <div class="row-space-between">
          <div class="padding-right">
            <div>
              <strong>{{
                'cookies-dialog.text.essential-cookies' | translate
              }}</strong>
            </div>
            <div>
              {{
                'cookies-dialog.text.essential-cookies-description' | translate
              }}
            </div>
          </div>

          <div>
            <mat-slide-toggle
              color="primary"
              [formControlName]="FORM_NAME.ESSENTIAL"
            ></mat-slide-toggle>
          </div>
        </div>

        <lib-spacer></lib-spacer>

        <div class="row-space-between">
          <div class="padding-right">
            <div>
              <strong>{{
                'cookies-dialog.text.statistics-cookies' | translate
              }}</strong>
            </div>
            <div>
              {{
                'cookies-dialog.text.statistics-cookies-description' | translate
              }}
            </div>
          </div>

          <div>
            <mat-slide-toggle
              color="primary"
              [formControlName]="FORM_NAME.ANALYSIS_AND_STATISTICS"
            ></mat-slide-toggle>
          </div>
        </div>
      </form>
    </ng-template>
  </div>

  <ng-container action>
    <button
      mat-stroked-button
      color="primary"
      [disabled]="!isAbleToSubmit()"
      (click)="submit()"
    >
      {{ 'cookies-dialog.buttons.save' | translate }}
    </button>

    <button
      mat-flat-button
      color="primary"
      [disabled]="!isAbleToSubmit()"
      (click)="acceptAllAndSubmit()"
    >
      {{ 'cookies-dialog.buttons.accept-all' | translate }}
    </button>
  </ng-container>
</lib-dialog>
